var map = {
	"./plan_product_default_cover.jpg": 32,
	"./医疗险.jpg": 69,
	"./寿险.jpg": 70,
	"./年金险.jpg": 71,
	"./意外险.jpg": 72,
	"./重疾险.jpg": 73,
	"./防癌险.jpg": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;